export default {
  buttons: {
    create: 'Create',
    update: 'Update',
    cancel: 'Cancel',
  },
  fields: {
    title: {
      label: 'Title',
      placeholder: 'Enter Title',
    },
    description: {
      label: 'Description',
      placeholder: 'Enter Description',
    },
    button_text: {
      label: 'Button Text',
      placeholder: 'Enter Button Text',
    },
    button_url: {
      label: 'Button Url',
      placeholder: 'https://example.com',
    },
    image: {
      label: 'Image',
    },
  },
  title: 'Create post',
};
